import React, { useState, useEffect, useRef } from "react";
import configData from "../../config.json";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import AlertShow from "./AlertShow";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import CallIcon from "@mui/icons-material/Call";
function Followup({
  followupdata,
  setVideo,
  sendMessage,
  audioVideo,
  handleChangeConsultationView,
  consultaionId,
  chatwindow,
}) {
  const chatContainerRef = useRef(null);
  const pollTimeoutRef = useRef(null);
  const abortRef = useRef(null);
  const isUserAtBottomRef = useRef(true);
  const SCROLL_THRESHOLD_PX = 100;
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px)" && "(max-width: 1023px)",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const [open, setOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [prescriptionImages, setPrescriptionImages] = useState([]);

  const heading = {
    paddingTop: "48px",
    fontSize: isTabScreen ? "24px" : "30px",
    color: configData.THEME_COLORS.PRIMARY,
    fontFamily: "Poppins",
    fontWeight: "500",
    color: "#F0588B",
    textAlign: "center",
  };
  const innerdiv = {
    display: "flex",
    paddingTop: "25px",
    alignItems: "center",
    justifyContent: "center",
  };
  const nm = {
    color: "#004AAD",
    fontSize: isTabScreen ? "16px" : "20px",
    fontWeight: "600",
    paddingLeft: "13px",
  };
  const post = {
    color: "#333333",
    paddingLeft: "13px",
    fontSize: isTabScreen ? "12px" : "16px",
    fontWeight: "400",
  };
  const consultationno = {
    color: "#004AAD",
    fontSize: isTabScreen ? "13px" : "20px",
    fontWeight: "400",
    paddingTop: "25px",
    paddingBottom: "20px",
    textAlign: "center",
    paddingLeft: "151px",
  };
  const msgbox = {
    height: "400px",
    width: "90%",
    margin: "0px auto",
    backgroundColor: "#FFF0F5",
  };
  const msg = {
    height: "350px",
    overflowY: "auto",
    overflowX: "hidden",
  };
  const nmimg = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
  };
  const menu = {
    width: "80px",
    height: "60px",
    backgroundColor: "gray",
    position: "absolute",
    top: "67%",
    right: "5%",
  };
  const submenu = {
    margin: "5px",
    backgroundColor: "#141124",
    fontSize: "13px",
    textAlign: "center",
    color: "white",
  };
  const inputbox = {
    height: "40px",
    width: "90%",
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: "7px",
  };
  const innerinput = {
    border: "none",
    height: "40px",
  };
  const [showdiv, setshowdiv] = useState(false);
  const [message, setMessage] = useState("");
  const [incomingmsg, setIncomingmsg] = useState([]);
  useEffect(() => {
    console.log("scrollto bot");
  }, []);
  // Start polling messages with cleanup on unmount and when followup identifiers change
  useEffect(() => {
    let isMounted = true;
    const senderId = followupdata?.doctor_id;
    const receiverId = followupdata?.patient_id;
    const consultationId = followupdata?.id;

    if (!senderId || !receiverId || !consultationId) {
      setIncomingmsg([]);
      return undefined;
    }

    const startPolling = () => {
      if (abortRef.current) {
        try {
          abortRef.current.abort();
        } catch (_) { }
      }
      abortRef.current = new AbortController();

      axios
        .post(
          `${configData.SERVER_API_URL}/inbox/get_message`,
          {
            sender_id: senderId,
            reciever_id: receiverId,
            consultation_id: consultationId,
          },
          { signal: abortRef.current.signal }
        )
        .then((response) => {
          if (!isMounted) return;
          if (response.status === 200) {
            const messages = response.data.messages.map((msg) => {
              const utcTimestamp = msg.created_at;
              const dateObject = new Date(utcTimestamp);
              const istTimestamp = dateObject.toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
              });

              return {
                ...msg,
                created_at_ist: istTimestamp,
              };
            });
            setIncomingmsg(messages.reverse());
          } else {
            const msg = "Error";
            const error_color = "error";
            handleAlertMsg(error_color, msg);
          }
        })
        .catch((error) => {
          if (error?.name !== "CanceledError") {
            console.error("Error in fetching messages");
          }
        })
        .finally(() => {
          if (!isMounted) return;
          if (isUserAtBottomRef.current) {
            scrollToBottom();
          }
          pollTimeoutRef.current = setTimeout(startPolling, 1000);
        });
    };

    startPolling();

    return () => {
      isMounted = false;
      if (pollTimeoutRef.current) {
        clearTimeout(pollTimeoutRef.current);
        pollTimeoutRef.current = null;
      }
      if (abortRef.current) {
        try {
          abortRef.current.abort();
        } catch (_) { }
      }
    };
  }, [followupdata?.doctor_id, followupdata?.patient_id, followupdata?.id]);
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };
  const handleScroll = (e) => {
    const el = e.target;
    const atBottom =
      el.scrollTop + el.clientHeight >= el.scrollHeight - SCROLL_THRESHOLD_PX;
    isUserAtBottomRef.current = atBottom;
  };
  const getmsg = async () => {
    if (!followupdata?.doctor_id || !followupdata?.patient_id || !followupdata?.id) {
      return;
    }

    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/inbox/get_message`,
        {
          sender_id: followupdata.doctor_id,
          reciever_id: followupdata.patient_id,
          consultation_id: followupdata?.id,
        }
      );
      if (response.status === 200) {
        const messages = response.data.messages.map((msg) => {
          const utcTimestamp = msg.created_at;
          const dateObject = new Date(utcTimestamp);
          const istTimestamp = dateObject.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          });

          return {
            ...msg,
            created_at_ist: istTimestamp,
          };
        });
        setIncomingmsg(messages.reverse());
      } else {
        const msg = "Error";
        const error_color = "error";
        handleAlertMsg(error_color, msg);
      }
    } catch (e) {
      console.error("Error in fetching messages");
    } finally {
      if (isUserAtBottomRef.current) {
        scrollToBottom();
      }
    }
  };

  const handleSendMessage = async () => {
    if (!followupdata?.doctor_id || !followupdata?.patient_id || !followupdata?.id) {
      const msg = "Chat details are unavailable for this consultation.";
      const error_color = "error";
      handleAlertMsg(error_color, msg);
      return;
    }

    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/inbox/send_message`,
        {
          sender_id: followupdata.patient_id,
          reciever_id: followupdata.doctor_id,
          message: message,
          consultation_id: followupdata?.id,
        }
      );
      if (response.status === 200) {
        // Do not show success notification to match Chat.js behavior
      } else {
        const msg = "error";
        const error_color = "error";
        handleAlertMsg(error_color, msg);
      }
    } catch {
      console.log("error in sending msg");
    }

    getmsg();
    setMessage("");
  };

  const fetchPrescriptionImages = async () => {
    try {
      console.log(
        "Fetching prescription image for consultationId:",
        followupdata?.id
      );
      const response = await axios.post(
        `${configData.SERVER_API_URL}/inbox/get_PrescriptionImage`,
        { consultation_id: followupdata?.id }
      );
      if (
        response.status === 200 &&
        response.data &&
        response.data.data &&
        response.data.data.message
      ) {
        const imageUrl = response.data.data.message;
        setSelectedImage(imageUrl);
        setOpen(true);
      } else {
        alert("No prescription image found.");
      }
    } catch (error) {
      console.error("Error fetching prescription image:", error);
    }
  };

  const getISTDate = (timestamp) => {
    const dateObject = new Date(timestamp);
    // Backend timestamps are 5h30m behind intended IST display in chat.
    return new Date(dateObject.getTime() + 660 * 60 * 1000);
  };

  const formatTime = (timestamp) => {
    const istDate = getISTDate(timestamp);
    let hours = istDate.getUTCHours();
    const minutes = istDate.getUTCMinutes().toString().padStart(2, "0");
    const amPm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${hours}:${minutes} ${amPm}`;
  };
  const formatDateKey = (timestamp) => {
    const istDate = getISTDate(timestamp);
    const day = istDate.getUTCDate().toString().padStart(2, "0");
    const month = (istDate.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = istDate.getUTCFullYear();

    return `${day}/${month}/${year}`;
  };
  const formatDateLabel = (timestamp) => {
    const istDate = getISTDate(timestamp);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = istDate.getUTCDate().toString().padStart(2, "0");
    const month = months[istDate.getUTCMonth()];
    const year = istDate.getUTCFullYear();

    return `${day} ${month} ${year}`;
  };
  const showoption = () => {
    setshowdiv(!showdiv);
  };

  const handleAlertMsg = (error_type, msg) => {
    setShowAlert(true);
    setSeverity(error_type);
    setAlertMsg(msg);
    setTimeout(() => {
      setShowAlert(false);
    }, 2500);
  };

  const handleClose = () => setOpen(false);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };
  const modopen = (imageUrl) => {
    setOpen(true);
    setSelectedImage(imageUrl);
  };

  return (
    <div style={{ width: "100%" }}>
      <hr className="w-100"></hr>
      <div style={innerdiv} className="py-4">
        <div>
          <img
            style={{ width: "75px", height: "75px" }}
            src={
              followupdata?.profile_pic
                ? "https://admin.myprega.com/" + followupdata?.profile_pic
                : "/profile/Group-1151.png"
            }
            alt="not found"
          />
        </div>
        <div>
          <div style={nm}>
            Dr {followupdata?.doctor_firstName} {followupdata?.doctor_lastName}
          </div>
          <div style={post}>{followupdata?.drpost}</div>
        </div>
      </div>
      <hr className="w-100"></hr>
      <div style={nmimg}>
        <div style={consultationno}>
          Consultation {" " + followupdata?.consultation_number}
        </div>
        <div className="d-flex align-items-center">
          {followupdata?.consultation_type == "Online" && (
            <>
              <button
                style={{
                  backgroundColor: "#eb6391",
                  color: "white",
                  padding: "5px 10px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onClick={fetchPrescriptionImages}
              >
                View Prescription
              </button>

              {audioVideo && (
                <div className="my-3 text-end">
                  <CallIcon
                    style={{
                      color: "#eb6391",
                      fontSize: 30,
                      cursor: "pointer",
                      marginRight: "16px",
                    }}
                    onClick={() => {
                      handleChangeConsultationView("audio");
                    }}
                  />

                  <VideoCallIcon
                    style={{
                      color: "#eb6391",
                      fontSize: 35,
                      cursor: "pointer",
                      marginRight: "16px",
                    }}
                    onClick={() => {
                      handleChangeConsultationView("video");
                    }}
                  />
                </div>
              )}
            </>
          )}
          {/* <img
            alt="not found"
            className="pe-3"
            src={"/DoctorConsultation/Shape.png"}
            onClick={() => showoption()}
          />
          {showdiv && (
            <div style={menu}>
              <div style={submenu}>Clear chat</div>
              <div style={submenu}>Delete</div>
            </div>
          )} */}
        </div>
      </div>

      <div style={msgbox}>
        {/* {followupdata?.consultation_type == "Online" && (
          <>
          <button
             style={{
               backgroundColor: "#eb6391",
               color: "white",
               padding: "5px 10px",
               border: "none",
               borderRadius: "5px",
               cursor: "pointer",
               marginRight: "10px"
             }}
             onClick={fetchPrescriptionImages}
           >
             View Prescription
           </button>

            {audioVideo && (
              <div className="my-3 text-end">
                <CallIcon
                  style={{
                    color: "#eb6391",
                    fontSize: 30,
                    cursor: "pointer",
                    marginRight: "16px",
                  }}
                  onClick={() => {
                    handleChangeConsultationView("audio");
                  }}
                />

                <VideoCallIcon
                  style={{
                    color: "#eb6391",
                    fontSize: 35,
                    cursor: "pointer",
                    marginRight: "16px",
                  }}
                  onClick={() => {
                    handleChangeConsultationView("video");
                  }}
                />
              </div>
            )}
          </>
        )} */}

        <div style={msg} ref={chatContainerRef} onScroll={handleScroll}>
          <div className="p-2 py-2 mx-auto my-2 w-75 defaultmsg">
            Messages are end-to-end encrypted. No one outside of this chat, not
            even MyPrega, can read or listen to them.
          </div>
          {incomingmsg && incomingmsg.length > 0 ? (
            incomingmsg.map((item, index) => {
              const currentDate = formatDateKey(item.created_at);
              const prevDate =
                index > 0
                  ? formatDateKey(incomingmsg[index - 1].created_at)
                  : null;
              const shouldDisplayDate = currentDate !== prevDate;

              return (
                <div key={item.id}>
                  {shouldDisplayDate && (
                    <div
                      className="mx-auto mt-1 text-white d-flex justify-content-center align-items-center"
                      style={{
                        width: "90px",
                        height: "30px",
                        fontSize: "11px",
                        backgroundColor: "rgb(240, 88, 139)",
                        borderRadius: "14px",
                      }}
                    >
                      {formatDateLabel(item.created_at)}
                    </div>
                  )}

                  {/* Render the message */}
                  <div className="mx-2 my-2">
                    {item.is_image ? (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => modopen(item.message)}
                        className={`p-2 ${followupdata.patient_id === item.user_id
                            ? "leftsideclassimg"
                            : "rightsideclass1"
                          }`}
                      >
                        <img
                          src={item.message}
                          className="imgmsg"
                          alt="not found"
                        />
                        <div
                          className="text-end"
                          style={{
                            color:
                              followupdata.patient_id === item.user_id
                                ? "black"
                                : "#c4c4c4",
                            fontSize: "8px",
                          }}
                        >
                          {formatTime(item.created_at)}
                        </div>
                      </div>
                    ) : item.is_system_generated === 1 && item.is_read === 1 ? (
                      <div
                        className="p-2 py-2 mx-auto my-2 w-75 defaultmsg"
                        style={{ background: "gray", color: "#fff" }}
                      >
                        {item.message}
                      </div>
                    ) : item.is_system_generated === 1 && item.is_read === 0 ? (
                      <div
                        className="p-2 py-2 mx-auto my-2 w-75 defaultmsg"
                        style={{ background: "pink", color: "#111" }}
                      >
                        {item.message}
                      </div>
                    ) : item.is_system_generated === 0 && item.is_read === 0 ? (
                      <div
                        className={`p-2 ${followupdata.patient_id === item.user_id
                            ? "leftsideclass1 mlauto"
                            : "rightsideclass1"
                          } ${item.message?.length > 18 ? "setwidth" : "removewidth"
                          }`}
                      >
                        {item.message}
                        <div
                          className="text-end"
                          style={{
                            color:
                              followupdata.patient_id === item.user_id
                                ? "black"
                                : "#c4c4c4",
                            fontSize: "8px",
                          }}
                        >
                          {formatTime(item.created_at)}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="pt-2 text-center">No messages available.</p>
          )}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            size="lg"
          >
            <Box className="modal-container">
              <div
                className="modal-content text-end w-50"
                style={{ backgroundColor: "#FFF0F5" }}
              >
                <span
                  className="close"
                  onClick={handleClose}
                  style={{ color: "black" }}
                >
                  &times;
                </span>
                <div className="modal-content-scrollable">
                  <img
                    src={selectedImage}
                    alt="Full-size Image"
                    style={{ width: "100%" }}
                  />
                  {/* Add your medicine list here */}
                </div>
              </div>
            </Box>
          </Modal>
        </div>
        {sendMessage && (
          <div className="mx-2" style={inputbox}>
            <img
              alt="not found"
              src="/DoctorConsultation/Attachbutton.png"
              className="mx-2"
            // onClick={}
            />
            <input
              className="w-75"
              type="text"
              style={innerinput}
              value={message}
              placeholder="Type your message..."
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && message.trim().length) {
                  e.preventDefault();
                  handleSendMessage();
                }
              }}
            />
            <img
              alt="not found"
              src="/DoctorConsultation/sendbtn.png"
              className="mx-2"
              onClick={handleSendMessage}
            />
          </div>
        )}
      </div>
      <AlertShow
        alertShowHide={showAlert}
        alertClose={handleCloseAlert}
        setalertMsg={alertMsg}
        severity={severity}
      />
    </div>
  );
}

export default Followup;
